export const team26 = [{
    "year": 2026,
    "CoreTeam": [
        {
            "Position": "Chairperson",
            "Name": "B. Vedasi Chowdary",
            "SocialHandles": [
                "https://www.linkedin.com/in/vedasi-balla-454337283/"
            ],
            "ImgPath": "Vedasi.jpg"
        },
        {
            "Position": "Vice Chairperson",
            "Name": "G. Vedvardhan",
            "SocialHandles": [
                "https://www.linkedin.com/in/vedvardhan-gyanmote-566995201/"
            ],
            "ImgPath": "Ved.jpeg"
        },
        {
            "Position": "Secretary",
            "Name": "T. Murali Samant",
            "SocialHandles": [
                "https://www.linkedin.com/in/murali-samant-tejomurtula-51588231a/"
            ],
            "ImgPath": "Murali.jpeg"
        },
        {
            "Position": "Treasurer",
            "Name": "B. V. Swapanthi",
            "SocialHandles": [
                "https://www.linkedin.com/in/venkata-swapanthi-bommidi/"
            ],
            "ImgPath": "Swapanthi.jpeg"
        },
        {
            "Position": "Membership Chair",
            "Name": "G. Shreshtha",
            "SocialHandles": [
                "https://www.linkedin.com/in/saishreshta-gudipati/"
            ],
            "ImgPath": "Shreshta.jpeg"
        },
        {
            "Position": "Activities Coordinator",
            "Name": "J. Shradha",
            "SocialHandles": [
                "https://www.linkedin.com/in/juluri-shradha-3103a131a/"
            ],
            "ImgPath": "Shradha.jpg"
        }
    ],
    "TeamHeads": [
        {
            "Position": "Social Media Head",
            "Name": "D. Nikitha Reddy",
            "SocialHandles": [
                "https://www.linkedin.com/in/nikitha-reddy-danda/"
            ],
            "ImgPath": "Nikitha.jpeg"
        },
        {
            "Position": "Events & PR Head",
            "Name": "N. Siri Chandana",
            "SocialHandles": [
                "https://www.linkedin.com/in/siri-chandana-nallamothu/"
            ],
            "ImgPath": "Siri_Chandana.jpg"
        },
        {
            "Position": "Technical Head",
            "Name": "A. Mani Shankar",
            "SocialHandles": [
                "https://www.linkedin.com/in/a-manishankar/"
            ],
            "ImgPath": "Mani_Shankar.png"
        },
        {
            "Position": "Design Team Head",
            "Name": "K. Bavitha",
            "SocialHandles": [
                "https://www.linkedin.com/in/bavitha-kolli-9544b4226/"
            ],
            "ImgPath": "Bavitha.jpg"
        },
        {
            "Position": "Coding Team Head",
            "Name": "M. Shashi Preetham",
            "SocialHandles": [
                "https://www.linkedin.com/in/shashipreethammiryala/"
            ],
            "ImgPath": "Shashi.jpg"
        },
        {
            "Position": "Creative Team Head",
            "Name": "M. Sreeamritha",
            "SocialHandles": [
                "https://www.linkedin.com/in/amritha-reddy-78a001306/?utm_source=share_via&utm_content=profile&utm_medium=member_ios"
            ],
            "ImgPath": "amritha.jpeg"
        }
    ],
    "Volunteers": [
        {
            "Name": "Rohan Ginjupalli",
            "Mail": "rohanchowdary00@gmail.com",
            "Team": "Technical ",
            "imgPath": "avatar.png",
            "linkedin": "www.linkedin.com/in/rohanginjupalli"
        },
        {
            "Name": "K.Sathvik",
            "Mail": "kansathv@gmail.com",
            "Team": "Technical ",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/sathvik-kandukuri-6b94402a3/"
        },
        {
            "Name": "G.Vennela",
            "Mail": "gurrapuvennela5@gmail.com",
            "Team": "Technical",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/vennela-gurrapu-520302326"
        },
        {
            "Name": "Nandini Sunkara",
            "Mail": "nandinisunkara7.7@gmail.com",
            "Team": "Technical",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/nandini-sunkara-644990311/"
        },
        {
            "Name": "M.S.Shritan",
            "Mail": "shritan.medisetti.2507@gmail.com",
            "Team": "Events and PR",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/shritan-medisetti-3a7b84325"
        },
        {
            "Name": "Sri Varsha Mekala",
            "Mail": "varshamekala57@gmail.com",
            "Team": "Events and PR",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/sri-varsha-mekala-004755352/"
        },
        {
            "Name": "Katakam Yashi Rukmini Dhanalakshmi",
            "Mail": "katakamyashi11@gmail.com",
            "Team": "Events and PR",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/yashi-rukmini-dhanalakshmi-katakam-16bb971b5/"
        },
        {
            "Name": "B. Vidhatri",
            "Mail": "vidhatrib127@gmail.com",
            "Team": "Events and PR",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/vidhatri-sreenivas-bb7b74395?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
        },
        {
            "Name": "Srinivasa Prasad Gade",
            "Mail": "srinivasaprasad.gade@gmail.com",
            "Team": "Events and PR",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/srinivasaprasad-gade-5841a9326?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
        },
        {
            "Name": "Akhila T",
            "Mail": "akhilatungachela@gmail.com",
            "Team": "Social Media",
            "imgPath": "avatar.png",
            "linkedin": "http://linkedin.com/in/akhila-tungachela"
        },
        {
            "Name": "Nivedita M",
            "Mail": "maddunivedita@gmail.com",
            "Team": "Social Media",
            "imgPath": "avatar.png",
            "linkedin": "www.linkedin.com/in/nivedita-maddu"
        },
        {
            "Name": "M.Prashasti",
            "Mail": "prashastim0412@gmail.com",
            "Team": "Social Media",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/prashasti-mahankali-b48768333?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
        },
        {
            "Name": "Sk.Almas sania",
            "Mail": "almassaniashaik06@gmail.com",
            "Team": "Social Media",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/shaik-almas-sania-a134bb36a?utm_source=share_via&utm_content=profile&utm_medium=member_android"
        },
        {
            "Name": "Vadlakonda Abhiram",
            "Mail": "abhivadlakonda2333@gmail.com",
            "Team": "Social Media",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/abhi-abhi-8232ba240?utm_source=share_via&utm_content=profile&utm_medium=member_android"
        },
        {
            "Name": "Sunki Sanjali Reddy",
            "Mail": "sanjalireddysunki06@gmail.com",
            "Team": "Design",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/sanjali-reddy-79b53b326?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
        },
        {
            "Name": "S. Akhil",
            "Mail": "joshuasrirangam@gmail.com",
            "Team": "Design",
            "imgPath": "avatar.png",
            "linkedin": "www.linkedin.com/in/akhil-joshua"
        },
        {
            "Name": "Harshith Gangisetty",
            "Mail": "harshithgangisetty7@gmail.com",
            "Team": "Design",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/gangisetty-harshith-5a40ab364?utm_source=share_via&utm_content=profile&utm_medium=member_android"
        },
        {
            "Name": "A. Blessy Karen",
            "Mail": "blessykaren07@gmail.com",
            "Team": "Creative",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/blessy-karen-amudala-403825326?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
        },
        {
            "Name": "P. Akhilesh",
            "Mail": "p.akhil3431@gmail.com",
            "Team": "Creative",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/pasham-akhilesh-yadav-26b372339?utm_source=share_via&utm_content=profile&utm_medium=member_android"
        },
        {
            "Name": "P. Anirvaa",
            "Mail": "anirvaa19@gmail.com",
            "Team": "Creative",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/anirvaa-pitla-49a18b329/"
        },
        {
            "Name": "C. Akshita",
            "Mail": "akshitac.2020@gmail.com",
            "Team": "Creative",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/akshitac-chatharasupalli-22/"
        },
        {
            "Name": "Madhav Sampreet Tejomurtula",
            "Mail": "mstejomurtula@gmail.com",
            "Team": "Creative",
            "imgPath": "avatar.png",
            "linkedin": "https://www.linkedin.com/in/madhavsampreettejomurtula?utm_source=share_via&utm_content=profile&utm_medium=member_ios"
        },
        {
            "Name": "Thipparthi Nikhil Reddy",
            "Mail": "thipparthinikhilreddy4445@gmail.com",
            "Team": "Coding",
            "linkedin": "https://www.linkedin.com/in/nikhil-reddy-thipparthi-802724297?utm_source=share_via&utm_content=profile&utm_medium=member_ios"
        },
        {
            "Name": "Nagolu Tejesh Reddy",
            "Mail": "tejesh.nagolu@gmail.com",
            "Team": "Coding",
            "linkedin": "https://www.linkedin.com/in/tejeshrn/"
        },
        {
            "Name": "Anikalla Sarika Reddy",
            "Mail": "sarikareddyanikalla178@gmail.com",
            "Team": "Coding",
            "linkedin": "https://www.linkedin.com/in/anikalla-sarika-reddy-809428292/"
        },
        {
            "Name": "Kolani Rishidhar Reddy",
            "Mail": "kolanirishidharreddy22@gmail.com",
            "Team": "Coding",
            "linkedin": "https://www.linkedin.com/in/rishidhar22"
        },
        {
            "Name": "Devasani Bharath",
            "Mail": "devasanibharath6@gmail.com",
            "Team": "Coding",
            "linkedin": "https://www.linkedin.com/in/bharath-devasani-68042b295?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
        },
        {
            "Name": "Madeehah",
            "Mail": "madeehah114@gmail.com",
            "Team": "Coding",
            "linkedin": "https://www.linkedin.com/in/madeehah-khanam-50498834b/"
        },
        {
            "Name": "Miryala Shashipreetham",
            "Mail": "miryalashashi.preetham@gmail.com",
            "Team": "Coding",
            "linkedin": "https://www.linkedin.com/in/shashipreethammiryala"
        },
        {
            "Name": "Vedasi Balla",
            "Mail": "bvedasichowdary@gmail.com",
            "Team": "Coding",
            "linkedin": "https://www.linkedin.com/in/vedasi-balla-454337283/"
        }
    ],
    "Test": [
        {
            "Name": "Shradha Juluri",
            "Desig": "Activities Coordinator(2025-2026)",
            "Content": "Engaging with ACM has been an enriching experience that enabled me to grow beyond academics. Collaborating with my team to organize events and interact with diverse participants offered valuable lessons in teamwork, organization, and communication. It inspired me to think beyond textbooks and realize how real-world experiences enhance learning.",
            "imgPath": "Shradha.jpg"
        },
        {
            "Name": "Vedasi Balla",
            "Desig": "Chairperson(2025-2026)",
            "Content": "ACM VNRVJIET has played a pivotal role in helping me discover my strengths and capabilities. The chapter provided me with the right environment to learn, explore, and grow through my experiences. As a volunteer in the technical team, contributing to website development and event design not only enhanced my technical skills but also helped me evolve personally and professionally. I am truly grateful to ACM VNRVJIET for offering me such a valuable and enriching opportunity.",
            "imgPath": "Vedasi.jpg"
        },
        {
            "Name": "Vedvardhan Gyanmote",
            "Desig": "Vice Chairperson(2025-2026)",
            "Content": "Being a part of the Technical Team at ACM VNRVJIET has been a transformative experience that went beyond technical learning. Working on website development and projects strengthened my coding, problem-solving, and innovation skills, while collaboration with peers improved my communication and teamwork. Taking ownership of tasks boosted my confidence and leadership, and participating in events enhanced my public speaking and organizational skills. I'm truly grateful to ACM VNRVJIET for providing a platform that nurtures both technical excellence and personal growth.",
            "imgPath": "Ved.jpeg"
        },
        {
            "Name": "Bavitha Kolli",
            "Desig": "Design Head(2025-2026)",
            "Content": "Volunteering at ACM VNRVJIET has been a truly enriching experience. It helped me step out of my comfort zone, explore new perspectives, and develop both my skills and mindset. Working with such a supportive team taught me the importance of collaboration and consistency. These experiences have made me more confident and open to new challenges. I’m grateful to ACM VNRVJIET for giving me this opportunity to learn and evolve.",
            "imgPath": "Bavitha.jpg"
        },
        {
            "Name": "T. Murali",
            "Desig": "Secretary(2025-2026)",
            "Content": "My journey with ACM VNRVJIET has been full of learning, collaboration, and growth. Working with such a motivated team helped me strengthen my communication, teamwork, and problem-solving skills while creating memories I'll always value.",
            "imgPath": "Murali.jpeg"
        },
        {
            "Name": "G. Sai Shreshta",
            "Desig": "Membership Chair(2025-2026)",
            "Content": "Joining ACM VNRVJIET opened doors to learning, growth, and self-discovery. Being part of the Events and PR team strengthened my teamwork, communication, and decision-making skills while helping me grow both personally and professionally. The experience taught me to stay organized, make thoughtful decisions, and approach challenges with creativity.",
            "imgPath": "Shreshta.jpeg"
        },
        {
            "Name": "N. Siri Chandana",
            "Desig": "Secretary(2025-2026)",
            "Content": "My journey as a volunteer at ACM VNRVJIET has been one of the most enriching and exciting parts of my college life. It allowed me to interact with amazing people, take part in event planning, and learn how to manage responsibilities efficiently. The encouragement and teamwork within ACM made every experience enjoyable and motivating. I truly value the lessons I learned and the confidence I gained through this opportunity.",
            "imgPath": "Siri_Chandana.jpg"
        },
        {
            "Name": "D. Nikitha Reddy",
            "Desig": "Social Media Head(2025-2026)",
            "Content": "Volunteering with ACM VNRVJIET has been a great learning experience. It gave me the opportunity to collaborate with talented peers and contribute to technical events. The supportive environment helped me enhance my leadership, communication, and organizational skills. Each event brought new challenges that pushed me to grow both personally and professionally. I’m truly grateful to be part of such a passionate and inspiring community.",
            "imgPath": "Nikitha.jpeg"
        }
    ]
}
]